/* eslint-disable react/display-name */
/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Image } from "@src/components/Image";
import { CONTENT_TYPE } from "@src/components/Tabs/Content/store/constants";
import getContentThumbnail from "@src/components/Tabs/Content/helpers/getContentThumbnail";
import { useRouter } from "@src/lib/router";
import * as actions from "@src/components/BottomSheets/store/actions.js";
import { getAwsAssets } from "@src/utils";
import contentHasThumbnail from "@src/components/Tabs/Content/helpers/contentHasThumbnail.js";
import handleOpenContent from "../../../Content/helpers/handleOpenContent";
import {
  installmentsAlertStateEnum,
  trackIDMap,
} from "@src/components/Tabs/Overview/store/constants.js";
import {
  funnelTrackAction,
  funnelTrackHistoryObjectAction,
} from "@src/components/Tabs/Overview/store/actions.js";
import { newWebEngage } from "@src/utils/webEngageEvent";
import { useTranslation } from "react-i18next";
import { getUserAgent } from "@src/utils/getAxiosConfig";
import { USER_AGENT_STRING } from "@src/utils/constants";
import { safeJsonParse } from "@src/utils/safeJsonParse";

import OtherTags from "./OtherTags";
import LikeButton from "../LikeButton/LikeButton";
import VideoProgressBar from "../../../Content/components/ContentList/VideoProgressBar";

// eslint-disable-next-line react/display-name
const DescriptionImage = React.memo(
  ({ url, handleItemClickedDeeplinkExecute, isEmpty, state }) => {
    if (isEmpty) {
      return (
        <Image
          className=""
          src={
            url
              ? url
              : getAwsAssets("FreeContentDefaultCourseImage.svg", "content")
          }
          alt="courseThumbnail"
          layout="fill"
          objectFit="cover"
          priority={true}
          loading="eager"
          width={200}
          height={150}
          onClick={() =>
            handleItemClickedDeeplinkExecute
              ? handleItemClickedDeeplinkExecute({
                  contentType: 3,
                  url:
                    url ||
                    getAwsAssets(
                      "FreeContentDefaultCourseImage.svg",
                      "content"
                    ),
                  format: "jpg",
                  name: state?.details?.name, //check async here
                  description: "",
                })
              : console.log("nothing to handle")
          }
        />
      );
    }
    return (
      <Image
        className=""
        src={
          url
            ? url
            : getAwsAssets("FreeContentDefaultCourseImage.svg", "content")
        }
        alt="courseThumbnail"
        layout="fixed"
        objectPosition={"50% 50%"}
        priority={true}
        loading="eager"
        objectFit="cover"
        width={200}
        height={150}
        onClick={() =>
          handleItemClickedDeeplinkExecute
            ? handleItemClickedDeeplinkExecute({
                contentType: 3,
                url:
                  url ||
                  getAwsAssets("FreeContentDefaultCourseImage.svg", "content"),
                format: "jpg",
                name: state?.details?.name, //check async here
                description: "",
              })
            : null
        }
      />
    );
  },
  areMatchesEqual
);
const MemoizedOtherTags = React.memo(({ courseTagList }) => {
  return (
    <section className="OverView__OtherTags blockSlide">
      {courseTagList?.map((item, i) => (
        <OtherTags key={`sdf${i}`} data={item} />
      ))}
    </section>
  );
}, areMatchesEqual);
const OverView = ({ overviewServerData }) => {
  const router = useRouter();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [courseThumbnails, setCourseThumbnails] = useState([]);
  const state = useSelector((state) => {
    if (state?.overviewReducer?.overViewDetails?.course?.details?.name) {
      return state?.overviewReducer?.overViewDetails?.course;
    } else return overviewServerData?.course;
  });
  const freeContentLength = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.freeContentCount
  );
  const funnelTrackObj = useSelector(
    (state) => state?.overviewReducer?.funnelTrackingHistoryObject
  );
  const bottomSheetData = useSelector((state) => state?.bottomSheetReducer);
  const orgId = useSelector((state) => state?.overviewReducer?.overViewDetails?.course
    ?.metaData?.orgId) ;
  
  const renderCategories = () => {
    let names = state?.categories?.map((c, i) => c.name);
    return <p className="OverView__Categories__text">{names?.join(" • ")}</p>;
  };
  // console.log(state);
  let names = state?.categories?.map((c) => c.name);

  const setItemsForCourseThumbnails = () => {
    // console.log(state, "[[[[[[[[[[[[[[[");

    if (state?.freeContent) {
      setCourseThumbnails([...state?.freeContent]);
    }
  };
  useEffect(() => {
    setItemsForCourseThumbnails();
  }, [state]);
  // console.log(courseThumbnails);

  // const installmentsEnum = {
  //   0: "UNPAID",
  //   1: "PENDING",
  //   2: "DUE",
  //   3: "PAID",
  // };
  // const installmentsAlertStateEnum = {
  //   0: "NO_ALERT",
  //   1: "7_DAYS_LEFT_EXPIRE",
  //   2: "COURSE_LOCKED",
  //   3: "TIGHT_BUDGET",
  // };
  // console.log(installmentsAlertStateEnum, "alertEnum");
  useEffect(() => {
    if (
      state?.installments?.installmentAlert?.alertState ===
        installmentsAlertStateEnum.DAYS_LEFT_EXPIRE &&
      !bottomSheetData?.showBottomStatesOnce?.isShowDueDateBottomSheet
    ) {
      dispatch(actions.showDueDateBottomSheetAction(true));
    }
    if (!funnelTrackObj?.courseOverview) {
      dispatch(
        funnelTrackAction({
          type: trackIDMap.courseOverview,
          isPurchased:
            state?.installments?.paidInstallmentSummary?.isPaymentComplete ===
              1 || state?.metaData?.isPurchased === 1,
          courseId: router?.query?.courseId,
        })
      );
      dispatch(funnelTrackHistoryObjectAction({ courseOverview: true }));
    }

    //  newWebEngage("Notifications_Landing Screen Done Click");
  }, []);
  const handleItemClickedDeeplinkExecute = (item) => {
    if (item?.isScheduled) {
      localStorage.setItem("currentItem", JSON.stringify(item));
      dispatch(actions.showContentLockedBottomSheetAction(true));
    }
    // console.log(item, "this is item");
    else {
      const isMobileAndroid = getUserAgent() === USER_AGENT_STRING.ANDROID;
      const isCorruptedAndroidVersion = safeJsonParse(window?.androidData, {
        source: "OverView [window.androidData]",
        fallback: null,
      });
      const enableWebVideoPlayer = isMobileAndroid && isCorruptedAndroidVersion?.appVersion === "1.6.1.3";
      if (item.contentType === CONTENT_TYPE.VIDEO && enableWebVideoPlayer) {
        dispatch(actions.toggleVideoBottomSheet({
          value: true,
          data: item
        }));
      } else {
        handleOpenContent(item);

      }
    }
  };
  return (
    <div className="OverView">
      <div className="OverView__Heading">
        <div className="OverView__Heading__Left CourseName">
          {state?.details?.name}
        </div>
        <div className="OverView__Heading__Right">
          {/* <img src={state?.likes?.icon} alt="/" /> */}
          <LikeButton value={state?.likes?.value} />
        </div>
      </div>
      <section className="OverView__Categories">{renderCategories()}</section>
      <MemoizedOtherTags courseTagList={state?.courseTagList} />
      <section
        className={
          !state?.freeContent?.length > 0
            ? "OverView__Content__Images Empty blockSlide"
            : "OverView__Content__Images blockSlide"
        }
        {...(!state?.freeContent?.length && !state?.details?.imageUrl
          ? { style: { margin: "12px 16px", padding: 0 } }
          : {})}
      >
        {!state?.freeContent?.length && !state?.details?.imageUrl ? null : (
          <React.Fragment>
            <div
              className={
                !state?.freeContent?.length > 0
                  ? "OverView__Content__Images__Empty"
                  : "OverView__Content__Images__Wrapper"
              }
            >
              {!state?.freeContent?.length > 0 ? (
                <>
                  <DescriptionImage
                    url={state?.details?.imageUrl}
                    state={state}
                    isEmpty
                    handleItemClickedDeeplinkExecute={
                      handleItemClickedDeeplinkExecute
                    }
                  />
                </>
              ) : (
                <DescriptionImage
                  url={state?.details?.imageUrl}
                  handleItemClickedDeeplinkExecute={
                    handleItemClickedDeeplinkExecute
                  }
                  state={state}
                />
              )}
            </div>
          </React.Fragment>
        )}

        {state?.freeContent?.map((item, i) => (
          <div
            // className="OverView__Content__Images__Wrapper freeContent"
            key={`${i}34df_33)`}
          >
            {CONTENT_TYPE?.TEST === item?.contentType ? null : (
              <div
                className="OverView__Content__Images__Wrapper freeContent"
                key={`${i}34df_)`}
                style={
                  contentHasThumbnail(item)
                    ? { background: `url(${getContentThumbnail(item)})` }
                    : {}
                }
                onClick={() => handleItemClickedDeeplinkExecute(item)}
              >
                <div style={{ position: "relative", marginBottom: "10px" }}>
                  {!contentHasThumbnail(item) && (
                    <Image
                      src={
                        getContentThumbnail(item) ||
                        getAwsAssets(
                          "FreeContentDefaultCourseImage.svg",
                          "content"
                        )
                      }
                      alt="desc"
                      width="48"
                      height="48"
                      // layout="fixed"
                      objectFit="contain"
                      // placeholder="blur"
                    />
                  )}
                </div>
                <div className="OverView__Content__Images__Wrapper freeContent__bottomText">
                  {item?.name}
                </div>

                {CONTENT_TYPE?.VIDEO === item?.contentType ? (
                  <div className="OverView__Content__freeContent__VideoPreview__play">
                    <div style={{ position: "relative" }}>
                      <Image
                        src={getAwsAssets("PlayWithWrapper.svg", "content")}
                        alt="a"
                        width="48px"
                        height="48px"
                        layout="fixed"
                        // objectFit="cover"
                      />
                    </div>
                  </div>
                ) : null}
                {CONTENT_TYPE?.VIDEO === item?.contentType && (
                  <div className="OverView__Content__Images__Wrapper__videoProgress">
                    <VideoProgressBar
                      lastSeek={item?.lastSeek}
                      duration={item?.duration}
                      videoMaxDuration={item?.videoMaxDuration}
                      featuredVideo
                    />
                  </div>
                )}

                {CONTENT_TYPE?.VIDEO === item?.contentType &&
                item?.duration !== undefined &&
                item?.duration != "undefined" ? (
                  <div className="OverView__Content__freeContent__VideoPreview__timer">
                    {item?.duration ? item?.duration : null}
                  </div>
                ) : null}
              </div>
            )}{" "}
          </div>
        ))}
        {freeContentLength >= 3 ? (
          <div
            className="OverView__Content__showMore"
            onClick={() => {
              router.push(`/${router.query.courseId}/freecontent`);
              newWebEngage("course_free_content_view", {
                action: "View All Free Content Click",
              });
            }}
          >
            <div className="OverView__Content__showMore__Arrow">
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  maxWidth: "32px",
                }}
              >
                <Image
                  src={getAwsAssets("ShowMoreRightArrow.svg", "content")}
                  alt="desc"
                  layout={"intrinsic"}
                  height={"32px"}
                  width={"32px"}
                  priority={true}
                  loading="eager"
                />
              </div>
            </div>
            <div className="OverView__Content__showMore__Text">
              {t(
                "components.tabs.overview.components.overview.viewAll",
                "View All"
              )}
            </div>
            <div className="OverView__Content__showMore__Text__2">
              {t(
                "components.tabs.overview.components.overview.freeContent",
                "Free Content"
              )}
            </div>
          </div>
        ) : null}
      </section>
    </div>
  );
};
function areMatchesEqual(prevProps, nextProps) {
  // console.log("waat", prevProps, nextProps);
  /**return (prevProps.match.MatchWinnerPrediction == nextProps.match.MatchWinnerPrediction && 
        prevProps.match.HomeGoalsPrediction == nextProps.match.HomeGoalsPrediction &&
        prevProps.match.AwayGoalsPrediction == nextProps.match.AwayGoalsPrediction);**/
  return false;
}
export default React.memo(OverView);
